import * as actions from './actions';

export type State = {};

const initialState = {
  accountType: {},
  accountName: '',
  balance: '',
  annualSavingsEE: '',
  annualSavingsER: '',
  owner: '',
  investmentMix: {
    stocks: '',
    bonds: '',
    shortTerm: '',
    other: '',
    investmentMixData: [0, 0, 0, 0, 100],
    hasError: false,
    activeField: '',
    stocksPlaceholder: 0,
    bondsPlaceholder: 0,
    shortTermPlaceholder: 0,
    otherPlaceholder: 0,
  },
  pension: {
    paymentMethod: { label: 'Monthly', value: 'monthly' },
    costOfLivingAdjustment: '',
    survivorBenefit: '',
    amount: '',
    startsAt: '',
  },
  showGlobalError: false,
  error: {
    investmentMix: 'Total allocation <br>must equal<br>100%',
    pension: {},
  },
};

export default (state: State = initialState, action: any): State => {
  switch (action.type) {
    case actions.UPDATE_FIELD:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};
